(() => {
  'use strict';
  const script = document.currentScript;
  const dialog = document.getElementById('luckcoo-region-gate');
  if (!script || !dialog || dialog.dataset.initialized) return;
  dialog.dataset.initialized = 'true';
  const retry = dialog.querySelector('[data-region-retry]');
  const policy = script.dataset.policy;
  const root = document.documentElement;
  let running = false;

  function state(value, reason) {
    root.dataset.luckcooRegion = value;
    script.dataset.state = value;
    script.dataset.reason = reason;
  }

  function release(value, reason) {
    if (dialog.open) dialog.close();
    state(value, reason);
  }

  function endpoint() {
    try {
      const url = new URL(script.dataset.endpoint);
      if (url.protocol !== 'https:' || url.username || url.password || url.search || url.hash || url.pathname !== '/v1/decision') return null;
      return url.href;
    } catch {
      return null;
    }
  }

  async function requestDecision(url) {
    const controller = new AbortController();
    let timer;
    try {
      return await Promise.race([
        (async () => {
          const response = await fetch(url, { method: 'GET', mode: 'cors', credentials: 'omit', cache: 'no-store', redirect: 'error', referrerPolicy: 'no-referrer', signal: controller.signal });
          if (!response.ok || !response.headers.get('content-type')?.includes('application/json')) throw new Error('response');
          const data = await response.json();
          if (data.schema !== 1 || data.policy !== policy) throw new Error('policy');
          if (!['allow', 'deny', 'unknown'].includes(data.decision)) throw new Error('decision');
          if (data.decision !== 'unknown' && !/^[A-Z]{2}$/.test(data.country || '')) throw new Error('country');
          return data;
        })(),
        new Promise((_, reject) => {
          timer = setTimeout(() => { controller.abort(); reject(new Error('timeout')); }, 1200);
        })
      ]);
    } finally {
      clearTimeout(timer);
    }
  }

  async function check() {
    if (running) return;
    running = true;
    if (retry) retry.disabled = true;
    state('checking', 'request');
    try {
      const url = endpoint();
      if (!url || typeof dialog.showModal !== 'function') {
        release('fail-open', 'configuration_or_browser');
        return;
      }
      let decision;
      for (let attempt = 0; attempt < 2; attempt += 1) {
        try {
          decision = await requestDecision(url);
          if (decision.decision !== 'unknown') break;
        } catch {
          decision = null;
        }
      }
      if (!decision || decision.decision === 'unknown') {
        release('fail-open', 'lookup_unavailable');
      } else if (decision.decision === 'allow') {
        release('allowed', 'country');
      } else {
        if (!dialog.open) dialog.showModal();
        state('denied', 'country');
      }
    } catch {
      release('fail-open', 'unexpected_error');
    } finally {
      running = false;
      if (retry) retry.disabled = false;
    }
  }

  dialog.addEventListener('cancel', (event) => event.preventDefault());
  if (retry) retry.addEventListener('click', check);
  check();
})();
